<template>
  <div class="home">
    <Hd :navChange="navChange" />

    <div class="row auto m_b_40">
      <!-- Top Section with Navigation and Carousel -->
      <div class="topBox w_100 flex align_c justify_between">
        <div class="classBox align_c h_100">
          <div class="tabList w_100 h_100">
            <div class="leftNav">
              <div
                v-for="(item, index) in fu_class"
                :key="index"
                class="item w_100 cursor tab_hover flex align_c justify_between"
                @mouseover="onHover(item.id)"
                @click="jumpList(item)"
              >
                <i class="iconfont" :class="item.icon"></i>
                <span class="name">{{ item.name }}</span>
                <i class="el-icon-arrow-right"></i>
                <div class="minList">
                  <div
                    v-for="(subItem, subIndex) in sun_class"
                    :key="subIndex"
                    class="minitem hover cursor"
                    @click.stop="jumpList2(subItem)"
                  >
                    <img :src="subItem.image" alt="" />
                    <span>{{ subItem.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="swiper h_100">
          <el-carousel class="h_100">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <a :href="item.url" target="_blank">
                <img class="w_100 h_100" :src="item.img" alt="" />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- Recommended Products Section -->
      <div class="tuijian">
        <div class="title w_100 h_100 flex align_c justify_evenly">
          <div class="line"></div>
          <span>推荐产品</span>
          <div class="line"></div>
        </div>
      </div>
      <el-divider></el-divider>

      <div class="hoverBox w_100 flex">
        <div
          v-for="(item, index) in GoodClass"
          v-show="item.isnav == 1"
          :key="index"
          :class="['hoverItem', { on: isChange == index }]"
          @mouseenter="handleMouseEnter(index)"
          @mouseleave="handleMouseLeave()"
          @click="jumpList(item)"
        >
          <div class="en_name m_b_10 absolute">{{ item.diyname }}</div>
          <div class="ch_name strong m_b_15 absolute">{{ item.name }}</div>
          <img class="m_b_25 absolute" :src="item.image" alt="" />
          <div class="tips absolute">{{ item.description }}</div>
          <div class="more absolute cursor" @click.stop="jumpList(item)">
            查看更多<i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <GoodList :list="goodlist" />
    </div>

    <!-- News Section -->
    <div class="newBox auto m_b_25">
      <div class="title m_b_40">文章推荐</div>
      <div class="tabNew flex w_100 m_b_40">
        <div class="left h_100">
          <div
            v-for="(item, index) in newClass"
            :key="index"
            :class="['item cursor', { on: isNew == index }]"
            @click="jumpto('newsList', item.id)"
            @mouseover="changeNew(item, index)"
          >
            {{ item.name }}
          </div>
        </div>

        <template v-if="newList.length">
          <div class="right h_100 flex justify_between">
            <img
              class="h_100"
              :src="firstNew.image"
              alt=""
              @click="jumpto('newsDetail', firstNew.id)"
            />
            <div class="newInfo flex flex_column justify_between h_100">
              <div class="date f_c_grey">{{ firstNew.createtime }}</div>
              <div
                class="tit cursor strong w_100 single_line_ellipsis"
                @click="jumpto('newsDetail', firstNew.id)"
              >
                {{ firstNew.title }}
              </div>
              <div class="cont w_100 multi_line_ellipsis f_c_grey">
                {{ firstNew.description }}
              </div>
              <div class="button">
                <el-button @click="jumpto('newsDetail', firstNew.id)">
                  查看详情
                </el-button>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty class="auto" description="暂无新闻"></el-empty>
        </template>
      </div>

      <div v-if="newList.length" class="newSwiper">
        <div class="mySwiper swiper w_90 auto h_100">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in newList.slice(1, 13)"
              :key="index"
              class="swiper-slide flex flex_column justify_between h_100"
            >
              <div class="date f_c_grey">{{ item.createtime }}</div>
              <div
                class="tit cursor strong w_100 single_line_ellipsis"
                @click="jumpto('newsDetail', item.id)"
              >
                {{ item.title }}
              </div>
              <div class="cursor hover" @click="jumpto('newsDetail', item.id)">
                <span>查看详情</span>
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>

    <!-- Company Section -->
    <div class="gsBox w_100">
      <div class="center w_100 h_100 auto flex justify_between">
        <div class="left h_100 w_40 flex flex_column justify_between">
          <div class="top">
            <div class="name strong">{{ company.title }}</div>
            <div class="min_name strong">{{ company.subtitle }}</div>
          </div>
          <div class="text multi_line_ellipsis">
            {{ company.description }}
          </div>
          <div class="good">
            <div class="strong m_b_10">宏钜开发和打造的产品系列主要包括：</div>
            <div class="goodList flex">
              <div
                v-for="(item, index) in fu_class"
                :key="index"
                class="gooditem m_b_10"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div
            class="btn f_c_red cursor flex align_c justify_between"
            @click="jumpto('our')"
          >
            <span class="f_c_red">阅读更多</span>
            <i class="el-icon-arrow-right f_c_red"></i>
          </div>
        </div>

        <div class="right h_100 w_50">
          <img :src="company.image" alt="" />
        </div>
      </div>
    </div>

    <Foot />
  </div>
</template>

<script>
import Hd from '@/components/head.vue'
import Foot from '@/components/foot.vue'
import GoodList from '@/components/goodList.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import {
  banner,
  getShopCategory,
  newsCategory,
  newsList,
  getGoodsList,
  getCompany,
  shipperState,
  index,
} from '../api/basisMG'

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: this.product.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.product.description,
        },
        { vmid: 'keywords', name: 'keywords', content: this.product.keywords },
        { vmid: 'og-title', property: 'og:title', content: this.product.title },
        {
          vmid: 'og-desc',
          property: 'og:description',
          content: this.product.description,
        },
        { vmid: 'og-type', property: 'og:type', content: 'product' },
      ],
    }
  },
  components: {
    Hd,
    Foot,
    GoodList,
  },
  data() {
    return {
      user_avatar: '',
      user_name: '',
      navChange: false,
      classShow: false,
      isChange: 0,
      isNew: 0,
      goodlist: [],
      swiper: null,
      bannerList: [],
      fu_class: [],
      sun_class: [],
      allClass: [],
      newClass: [],
      newList: [],
      firstNew: {
        image: '',
        id: '',
        createtime: '',
        title: '',
        description: '',
      },
      company: {},
      GoodClass: [],
      product: {
        title: '',
        description: '',
        keywords: '',
      },
    }
  },
  async created() {
    const res = await index()
    this.product = res.data
  },
  mounted() {
    window.addEventListener('scroll', this.watchScroll)
    this.initData()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchScroll)
    this.destroySwiper()
  },
  methods: {
    initData() {
      this.getBanner()
      this.getClass()
      this.getNewClass()
      this.getGoodsList()
      this.getCompany()
    },

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy()
        this.swiper = null
      }
    },

    // Navigation methods
    jumpList(item) {
      this.$router.push({
        name: 'list',
        query: { type: item.id },
      })
    },

    jumpList2(item) {
      this.$router.push({
        name: 'list',
        query: { type: item.pid, label: item.id },
      })
    },

    jumpto(page, id) {
      this.$router.push({
        name: page,
        query: { id },
      })
    },

    // Event handlers
    watchScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.navChange = scrollTop > 400
    },

    handleMouseEnter(index) {
      this.isChange = index
      this.goodlist = this.GoodClass[index].goodsList
    },

    handleMouseLeave() {
      // Optional: Reset hover state if needed
    },

    onHover(pid) {
      this.sun_class = this.allClass.filter((item) => item.pid == pid)
    },

    // API methods
    async getBanner() {
      try {
        const res = await banner({ type: '2' })
        if (res.code === 1) {
          this.bannerList = res.data
        } else {
          this.handleError(res.msg)
        }
      } catch (error) {
        this.handleError(error.message)
      }
    },

    async getClass() {
      try {
        const res = await getShopCategory()
        if (res.code === 1) {
          this.allClass = res.data
          this.fu_class = res.data.filter((item) => item.pid == 0)
        } else {
          this.handleError(res.msg)
        }
      } catch (error) {
        this.handleError(error.message)
      }
    },

    async getNewClass() {
      try {
        const res = await newsCategory()
        if (res.code === 1) {
          this.newClass = res.data
          this.changeNew(res.data[0], 0)
        } else {
          this.handleError(res.msg)
        }
      } catch (error) {
        this.handleError(error.message)
      }
    },

    async changeNew(item, index) {
      this.isNew = index
      try {
        const res = await newsList({
          category_id: item.id,
          page: '1',
          num: '',
        })
        if (res.code === 1) {
          this.newList = res.data.data
          this.firstNew = res.data.data[0]
          this.initSwiper()
        } else {
          this.handleError(res.msg)
        }
      } catch (error) {
        this.handleError(error.message)
      }
    },

    async getGoodsList() {
      try {
        const res = await getGoodsList()
        if (res.code === 1) {
          this.GoodClass = res.data
          this.goodlist = this.GoodClass[0].goodsList
        } else {
          this.handleError(res.msg)
        }
      } catch (error) {
        this.handleError(error.message)
      }
    },

    async getCompany() {
      try {
        const res = await getCompany()
        if (res.code === 1) {
          this.company = res.data
        } else {
          this.handleError(res.msg)
        }
      } catch (error) {
        this.handleError(error.message)
      }
    },

    // Helper methods
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('.mySwiper', {
          slidesPerView: 3,
          spaceBetween: 100,
          paginationClickable: true,
        })
      })
    },

    handleError(message) {
      this.$notify.error({
        title: '错误',
        message: message || '发生未知错误',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.home {
  background: $color_bg;

  .row {
    max-width: 1550px;
    min-width: 1300px;
    background: $color_white;
    border-radius: 10px;
    overflow: hidden;
    padding: 20px;

    .topBox {
      height: 460px;

      .classBox {
        width: 212px;

        .tabList {
          background: #f7f8fc;
          border-top-left-radius: 15px;
          overflow: hidden;
          z-index: 9;

          &:hover {
            overflow: visible;
          }

          .leftNav {
            position: relative;
            background: #f7f8fc;
            border-top-left-radius: 15px;
            z-index: 9999;

            .item {
              padding: 0 20px;
              height: 66px;

              .minList {
                display: none;
                position: absolute;
                top: 0;
                left: 209px;
                z-index: 99;
                height: 100%;
                width: max-content;
                box-shadow: 9px 3px 10px #ddd;
                overflow: hidden;
                transition: top 0.25s ease;
                background: $color_white;

                .minitem {
                  height: 66px;
                  width: 212px;
                  white-space: nowrap;
                  display: flex;
                  align-items: center;

                  img {
                    width: 40px;
                    margin: 0 20px;
                  }

                  &:hover {
                    background-color: $color_red;
                    color: #fff !important;
                  }
                }
              }

              &:hover {
                .minList {
                  display: flex !important;
                  flex-wrap: wrap;
                  flex-direction: column;
                }
              }
            }
          }
        }
      }

      .swiper {
        width: 85%;
        border-radius: 0px;
        overflow: hidden;
      }
    }

    .tuijian {
      width: 212px;
      height: 75px;

      .title {
        .line {
          height: 24px;
        }

        span {
          font-size: 24px;
        }
      }
    }

    .hoverBox {
      .hoverItem {
        position: relative;
        width: 23%;
        height: 450px;
        padding: 30px;
        overflow: hidden;
        transition: width 0.3s ease 0s;
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .en_name,
        .ch_name,
        .tips,
        .more {
          color: #363636;
        }

        .en_name {
          top: 30px;
          left: 30px;
          width: 70%;
        }

        .ch_name {
          font-size: 26px;
          top: 70px;
          left: 30px;
          width: 80%;
          z-index: 1;
        }

        img {
          width: 100%;
          height: 55%;
          top: 90px;
          left: 0px;
        }

        .tips {
          top: 400px;
          left: 75px;
          width: 55%;
          text-align: center;
        }

        .more {
          display: none;
          top: 400px;
          left: 30px;
          width: 55%;

          i {
            margin-left: 10px;
          }
        }

        &.on {
          box-shadow: 0px 0px 15px 0px #ccc;
          border-radius: 16px;
          z-index: 1;
          transform: scale(1.1, 1.1);
          transition: transform 0.5s;

          .tips {
            top: 115px;
            left: 30px;
            text-align: start;
            transition: top 0.2s ease 0s;
          }

          .more {
            display: block;
          }
        }
      }
    }
  }

  .newBox {
    max-width: 1550px;
    min-width: 1300px;

    .title {
      font-size: 24px;
    }

    .tabNew {
      height: 400px;

      .left {
        width: 144px;

        .item {
          padding: 0 40px;
          margin-bottom: 40px;

          &.on {
            position: relative;

            &::before {
              position: absolute;
              content: '';
              display: inline-block;
              width: 25px;
              height: 3px;
              background: $color_red;
              top: 11px;
              left: 0;
            }
          }
        }
      }

      .right {
        width: calc(100% - 144px);

        img {
          width: 48%;
        }

        .newInfo {
          width: 50%;
          padding: 40px 20px 0 0;

          .date {
            position: relative;

            &::after {
              content: '';
              display: inline-block;
              width: 35px;
              height: 2px;
              background: $color_red;
              position: absolute;
              bottom: -10px;
              left: 0;
            }
          }

          .tit {
            font-size: 18px;
          }

          .cont {
            height: 190px;
            -webkit-line-clamp: 9;
          }

          .button {
            width: 175px;
            height: 55px;
          }
        }
      }
    }

    .newSwiper {
      height: 240px;
      overflow: hidden;
      padding-bottom: 20px;

      .mySwiper {
        position: relative;
      }

      .swiper-pagination {
        bottom: -20px;
      }

      .swiper-slide {
        background: #fff;
        padding: 30px 20px 40px;

        .date {
          position: relative;

          &::after {
            content: '';
            display: inline-block;
            width: 35px;
            height: 2px;
            background: $color_red;
            position: absolute;
            bottom: -10px;
            left: 0;
          }
        }

        .tit {
          font-size: 18px;
        }
      }
    }
  }

  .gsBox {
    background: #fff;
    height: 665px;

    .center {
      max-width: 1550px;
      min-width: 1300px;
      padding: 100px 0;

      .name {
        font-size: 43px;
      }

      .text {
        -webkit-line-clamp: 5;
      }

      .good {
        .goodList {
          flex-wrap: wrap;

          .gooditem {
            width: 40%;

            &::before {
              content: '';
              display: inline-block;
              width: 10px;
              height: 10px;
              background: $color_red;
              margin-right: 10px;
            }
          }
        }
      }

      .btn {
        width: 135px;
        border: 1px solid $color_red;
        border-radius: 20px;
        padding: 10px 20px;
      }

      .right {
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  .home .newBox {
    padding: 0 30px;
  }

  .home .gsBox .center {
    padding: 100px 30px;
  }
}
</style>
